import React, {useContext} from 'react'
import {Box, makeStyles, Typography} from '@material-ui/core'
import {themeContext} from '@smartb/archetypes-ui-components'

const useStyles = (firstColor: string, secondColor: string) =>
    makeStyles(() => ({
        progressContainer: {
            flexGrow: 1,
            background: '#e2e2e2',
            height: '8px',
            borderRadius: '30px',
            overflow: 'hidden',
            position: 'relative',
        },
        progressBar: {
            height: '100%',
            borderRadius: '30px'
        },
        firstBar: {
            background: firstColor,
            position: 'absolute',
            zIndex: 2
        },
        secondBar: {
            background: secondColor,
            position: 'absolute',
            zIndex: 1
        },
        label: {
            fontSize: '13px !important',
            minWidth: 33
        },
        firstLabel: {
            marginRight: 2,
            color: `${firstColor} !important`
        },
        secondLabel: {
            marginLeft: 5,
            color: `${secondColor} !important`
        }
    }))

export interface ProgressBarProps {
    firstPercent: number
    firstColor?: string
    secondPercent?: number
    secondColor?: string
    withLabel?: boolean
    additionalLabel?: string
}

export const ProgressBar = (props: ProgressBarProps) => {
    const theme = useContext(themeContext)
    const { firstPercent, firstColor = theme.primaryColor, secondPercent, secondColor = theme.secondaryColor, withLabel = false, additionalLabel } = props
    const classes = useStyles(firstColor, secondColor)()

    // data-tag for the Onclick progation on the table component
    return (
        <Box display='flex' width='100%' alignItems='center'>
            {withLabel && (
                <Typography
                    className={`${classes.label} ${classes.firstLabel}`}
                    variant='body2'
                >{`${firstPercent}%`}</Typography>
            )}
            <div
                className={classes.progressContainer}
                data-tag='___react-data-table-allow-propagation___'
            >
                <div
                    data-tag='___react-data-table-allow-propagation___'
                    className={`${classes.progressBar} ${classes.firstBar}`}
                    style={{ width: `${firstPercent}%` }}
                ></div>
                {secondPercent > firstPercent && <div
                    data-tag='___react-data-table-allow-propagation___'
                    className={`${classes.progressBar} ${classes.secondBar}`}
                    style={{ width: `${secondPercent}%` }}
                ></div>}
            </div>
            {withLabel && secondPercent !== undefined && (
                <Typography
                    className={`${classes.label} ${classes.secondLabel}`}
                    variant='body2'
                >{`${secondPercent}%`}</Typography>
            )}
        </Box>
    )
}
